<template>
  <transition name="fade" mode="out-in" appear>
    <div class="col-span-full sm:col-span-full md:col-span-7">
      <transition name="fade" mode="out-in" leave>
        <div v-if="readyToRender && timeOutDone == true">
          <!-- Onboarding Modal -->

          <NewUser
            v-if="!!isNewUser"
            @close="closeNewUser"
          />
          <ForcePhoneModal
            v-if="!!showForcePhoneModal"
          />
          <OnboardingModal
            v-else-if="!!showOnboardingModal"
            @close="closeOnboarding"
          />

          <ConfirmUserDetails
            v-else-if="!!showConfirm && !closeConfirm && !isCompany"
            @done="closeConfirm = true"
          />
        </div>
      </transition>
      <h2 class="text-t1 mb-4" v-if="profile.companyName">Hej {{ (profile.companyName) ? profile.companyName : applicantData.firstName }}!</h2>
      <h2 class="text-t1 mb-4" v-else-if="(profile && profile.firstName) || (applicantData && applicantData.firstName)">Hej {{ (profile.firstName) ? profile.firstName : applicantData.firstName }}!</h2>
      <p class="text-b1 mb-8">Hur kan vi hjälpa dig idag?</p>

      <div v-if="this.loaded.indexOf('profile')>-1 && this.loaded.indexOf('subscriptions')>-1" class="flex flex-col mt-10">
        <div v-if="offerCount > 0" class="relative flex w-full p-[10px] pl-[24px] flex-row items-center justify-between gap-[10px] rounded-[10px] border border-[#E9E9E9] bg-white mb-4 md:mb-8">
          <div class="text-label absolute -top-100 left-6">
              <span
                class="px-2 py-1 rounded-sm"
                :class="'text-black bg-primary'"
              >
                Erbjudande
              </span>
          </div>
          <span>
            Du har {{offerCount}} {{ offerCount == 1 ? 'aktuellt erbjudande' : 'aktuella erbjudanden'}}.
          </span>

          <Button variant="tertiary" :to="{ path: '/erbjudanden' }" class="self-end">
            <span class="hidden sm:block">Till mina erbjudanden</span>
            <template #icon-after>
              <IconArrowRight class="hidden sm:block"/>
              <IconChevronRight class="md:hidden" />
            </template>
          </Button>

       </div>

        <div v-if="oldSubscriptionCount > 0" class="relative flex w-full p-[10px] pl-[24px] flex-row items-center justify-between gap-[10px] rounded-[10px] border border-[#E9E9E9] bg-white mb-6">
          <div class="text-label absolute -top-100 left-6">
              <span
                class="px-2 py-1 rounded-sm"
                :class="'text-black bg-primary'"
              >
                Bevakningar
              </span>
          </div>

          <span>
            Du har {{oldSubscriptionCount}} {{ oldSubscriptionCount == 1 ? 'bevakning' : 'bevakningar'}} om håller på att gå ut.
          </span>

          <Button variant="tertiary" :to="{ path: '/bevakningar' }" class="self-end">
            Till bevakningar
            <template #icon-after>
              <IconArrowRight />
            </template>
          </Button>
        </div>

      </div>

      <div class="grid grid-cols-1 gap-8 pb-8 md:grid-cols-8">
        <Laundry v-if="hasActiveOrTerminatedResidentalContract" :startLoading="this.loaded.indexOf('dashboard')>-1"/>
        <ErrorReporting v-if="hasActiveOrTerminatedContract" :startLoading="this.loaded.indexOf('dashboard')>-1" />
        <InfoScreenMessages v-if="hasActiveOrTerminatedResidentalContract" :startLoading="this.loaded.indexOf('dashboard')>-1" />
        <Invoices v-if="hasContract" :startLoading="this.loaded.indexOf('dashboard')>-1" />
        <QuePoints v-if="!isCompany" :startLoading="this.loaded.indexOf('dashboard')>-1" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { cookieStorage } from '@/helpers/storage';
import VueCookies from 'vue-cookies';
import dayjs from 'dayjs';
import Loader from '@/components/ui/loader';
import Button from '@/components/ui/button';
import IconArrowRight from '@/components/icons/IconArrowRight';
import ConfirmUserDetails from '@/components/confirm-user-details';
import AppendableList from '@/components/ui/appendable-list';
import Expandable from '@/components/ui/expandable';
import Modal from '@/components/ui/modal';
import Box from '@/components/ui/box';
import ErrorReporting from '@/pages/dashboard/error-reporting';
import InfoScreenMessages from '@/pages/dashboard/infoscreen-messages';
import Laundry from '@/pages/dashboard/laundry';
import Invoices from '@/pages/dashboard/invoices';
import QuePoints from '@/pages/dashboard/que-points';
import OnboardingModal from '@/pages/dashboard/onboarding-modal';
import NewUser from '@/pages/dashboard/newuser';
import ForcePhoneModal from '@/pages/dashboard/force-phone-modal';
import auth from '@/auth/index';
import IconChevronRight from "../../components/icons/IconChevronRight.vue";


export default {
  name: 'dashboard',
  components: {
    IconChevronRight,
    Box,
    Modal,
    Loader,
    AppendableList,
    Expandable,
    ConfirmUserDetails,
    Laundry,
    Invoices,
    InfoScreenMessages,
    ErrorReporting,
    QuePoints,
    OnboardingModal,
    IconArrowRight,
    Button,
    NewUser,
    ForcePhoneModal
  },
  data() {
    return {
      loaded: [],
      oldSubscriptionCount: 0,
      primaryEmailConfirmed: false,
      closeConfirm: false,
      timeOutDone: false
    };
  },
  computed: {
    ...mapGetters({
      subscriptions: 'subscriptions',
      hasApartment: 'hasApartment',
      hasValidApartmentContract: 'hasValidApartmentContract',
      authStatus: 'authStatus',
      siteinfo: 'siteinfo',
      primaryEmailIsInUse: 'primaryEmailIsInUse',
      profile: 'profile',
      hasConfirmedMessagesOnboarding: 'hasConfirmedMessagesOnboarding',
      applicantData: 'applicantData',
      hasActiveOrComingContract: 'hasActiveOrComingContract',
      hasActiveResidentalContract: 'hasActiveResidentalContract',
      hasActiveOrTerminatedResidentalContract: 'hasActiveOrTerminatedResidentalContract',
      hasActiveOrTerminatedContract: 'hasActiveOrTerminatedContract',
      hasContract: 'hasContract',
      offerCount:'offerCount',
      isNewUser: "isNewUser"
    }),
    readyToRender() {
      return this.loaded.includes('profile') && this.loaded.length > 1;
    },

    isSecondaryTenant() {
      return this.$store.getters.claims.some((el) => el == 'secondaryRentalContract');
    },
    isCompany() {
      return this.$store.getters.claims.some((el) => el == 'company');
    },
    latestLogin() {
      return dayjs(new Date()).add(365, 'days');
    },
    showConfirm() {
      if (!Array.isArray(this.$store.getters.claims) || this.$store.getters.claims.length <1) return false;
      if (this.isCompany) return false;
      if(!this.$store.getters.profile.firstName || (this.$store.getters.profile.firstName && this.$store.getters.profile.firstName.length < 2)) return false;

      if (this.applicantData && this.applicantData.lastLogin == null) return false; //first login


      //if confirm-popup has been closed without actually confirming- don't show until expired
      if (cookieStorage.getItem('credentialsConfirmed')) return false;

      //show if email missing
      if (this.loaded.indexOf('profile') > -1 && this.$store.getters.profile.firstName && this.$store.getters.profile.firstName.length >= 2 && this.$store.getters.profile.email == '') return true;

      if (this.siteinfo && this.siteinfo.userDetailsConfirmedDate != null) {
        //if details haven't been confirmed in 14 days - show popup
        if (dayjs(this.siteinfo.userDetailsConfirmedDate).diff(new Date(), 'days') <= -60)
          return true;
      } else if (this.siteinfo) {
        //if never confirmed
        return true;
      }

      return false;
    },

    showOnboardingModal() {
      if (this.isCompany) return false;
      if (!!this.hasConfirmedMessagesOnboarding) return false;
      else if (this.hasConfirmedMessagesOnboarding === false) return true;
      return false;
    },

    showForcePhoneModal() {
      if (this.isCompany) return false;
      if (this.loaded.indexOf('profile') === -1) return false;

      const phones = ['phoneMobile', 'phoneMobile2', 'phoneMobile3', 'phoneHome', 'phoneWork'];
      return !phones.some((field) => String(this.profile[field] || '').trim());
    },
  },

  async created() {
    if(!await auth.checkAuth()) {
      await this.$store.dispatch('logout');
    }

    // Köpoäng, aktiva bevakningar, erbjudanden, intresseanmälningar
    this.$store.cache.dispatch('getDashboard').finally(() => {
    });

    // Hämta namn för "Hej Ralf!"
    this.$store.cache.dispatch('fetchProfile').then((data) => {
      this.loaded.push('profile');
      this.loaded.push('dashboard');

      setTimeout(() => {
        this.timeOutDone = true;
      }, 2500);
    });

    // Se närmaste tvätttid
    this.$store.cache.dispatch('fetchContracts').then((data) => {});

    this.$store.cache.dispatch('fetchSubscriptions').then((data) => {
      if (this.$store.getters.subscriptions.length > 0) {
        var date = new Date();
        var expireDate = date.setDate(date.getDate() + 10);

        let expiringSubscriptions = this.$store.getters.subscriptions.filter(function (sub) {
          let waitingListDate = Date.parse(sub.waitingListPeriodTo);
          return waitingListDate <= expireDate;
        });

        this.oldSubscriptionCount = expiringSubscriptions.length;
      }
      this.loaded.push('subscriptions');
    });
  },
  methods: {
    closeOnboarding() {
      this.$store.dispatch('setHasConfirmedMessagesOnboarding', true)

      return this.$store
        .dispatch('confirmMessagesOnboarding')
        .then((result) => {

        })
        .finally(() => {
        });
    },

    closeNewUser() {
      this.$store.dispatch('setNewUser', false)
      this.$store.dispatch('setHasConfirmedMessagesOnboarding', true)
      VueCookies.set('credentialsConfirmed', true, 60 * 60 * 24 * 30);
      this.closeConfirm = true;
    }

  },
};
</script>
